import { uuid } from '@yola/ws-sdk';
import actionTypes from '../constants/action-types';
import { SELECT } from '../constants/trigger-types';

function registeredTools(state = [], action) {
  if (action.type !== actionTypes.REGISTER_TOOL) {
    return state;
  }

  return [
    ...state,
    {
      id: uuid(),
      triggerOn: SELECT,
      ...action.payload.tool,
    },
  ];
}

export default registeredTools;
